import {useContext, useEffect, useState} from "react";

// Context
import {UserAuthenticationContext} from "../../Context/UserAuthenticationContext";

// Hooks
import useFetchUserSubscription from "../../Hooks/User/useFetchUserSubscription";

// Assets
import AccountSubInfo from "../../Components/Layouts/Account/AccountSubInfo";
import AccountBasicInfo from "../../Components/Layouts/Account/AccountBasicInfo";

function Account() {
    const
        {userData, userDataLoading, getValidAccessToken, refreshUserData} = useContext(UserAuthenticationContext),
        {subscriptionData, subscriptionLoading} = useFetchUserSubscription({getValidAccessToken, userId: userData?.id});

    return (
        <div className="page page--account">
            <div className="page__heading">
                <h1>
                    <span>Welcome, {userData?.first_name}</span>
                </h1>
            </div>

            <div className="page__inner">
                <AccountBasicInfo
                    userData={userData}
                    isUserDataLoading={userDataLoading}
                    getValidAccessToken={() => getValidAccessToken()}
                    refreshUserData={refreshUserData}
                />

                <AccountSubInfo
                    sub={subscriptionData}
                    userData={userData}
                    isSubLoading={subscriptionLoading}
                />
            </div>
        </div>
    );
}

export default Account;
